<template>
  <div>
    <el-form ref="form" :model="form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
            <el-input
              class="search-input"
              v-model="form.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="btn">
            <el-button
              class="search-tabs_button"
              @click="onSearch"
              icon="el-icon-search"
              size="small"
              >查询</el-button
            >
            <el-button
              class="search-tabs_button"
              size="small"
              icon="el-icon-delete"
              @click="resetForm('form')"
              >清空</el-button
            >
            <!-- <el-button
              class="search-tabs_button"
              size="small"
              @click="onRefresh"
              icon="el-icon-refresh"
              >刷新</el-button
            > -->
            <el-button
              class="search-tabs_button"
              size="small"
              icon="el-icon-plus"
              @click="handleAdd"
              type="success"
              >新增</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UserSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formLabelWidth: '40px', // 对话框中 文本的尺寸
      // 表单内容
      form: {
        name: '',
      },
      loading: false,
    };
  },

  computed: {
    ...mapGetters([]),
  },
  watch: {},
  created() {},
  methods: {
    // 新增
    handleAdd() {
      this.$emit('addForm');
    },
    // 搜索，触发父组件请求数据的方法
    onSearch() {
      this.$emit('search', this.form);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      this.dateTime = '';
      this.registrationTime = [];
      this.userName = '';
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.search-tabs_button {
  margin: 0 10px;
}
</style>
